import React from 'react'
import { Button, Icon, IconButton, Modal, TextField } from '@material-ui/core'

function PaymentTermQuickAdd({
    paymentTermField,
    modal,
    setNewPaymentTerm,
    setPaymentTermField,
    addNewPaymentTerm,
    newPaymentTerm
}) {
  return (
    <Modal
        open={paymentTermField}
        className={modal}
    >
        <div style={{width:700,backgroundColor: 'white',borderRadius:9,display:'flex',alignItems:'center',flexDirection:'column',padding:'20px'}}>
            {/* <h1 style={{display:'flex',alignSelf:'flex-start',paddingLeft:'25px'}}>Create Contract Type</h1> */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center', width: "100%" }}>
                <h1>Create Payment Term</h1>
                <IconButton onClick={()=>{
                    setNewPaymentTerm('')
                    setPaymentTermField(false)
                }}>
                    <Icon>close</Icon>
                </IconButton>
            </div>

            {/* <p style={{marginBottom: '10px', width: '100%'}}>Submit the below form to add Payment Term.</p> */}

            <form className='w-full' onSubmit={addNewPaymentTerm}>
                <div style={{backgroundColor: 'rgb(239 239 239)', borderRadius:9, padding: '15px', width:'100%', marginBottom: '10px'}}>
                    <TextField
                        required
                        variant='outlined'
                        label="Payment Term"
                        fullWidth
                        value={newPaymentTerm}
                        style={{ width: '100%', backgroundColor: '#fff' }}
                        onChange={(e)=>{
                            setNewPaymentTerm(e.target.value)
                        }}
                        // error={errorPaymentTerm}
                        // helperText={errorPaymentTerm ? errorPaymentTerm : null}
                        FormHelperTextProps={{
                            style: { 
                                margin : 0, 
                                backgroundColor: '#f4f4f4',
                                width: '100%',
                                paddingTop: '2px'
                            }
                        }}
                    />
                </div>
                <div style={{display:'flex',gap:10, width:'100%'}}>
                    <Button 
                        variant='contained' type='submit' color='primary' size='small' style={{ borderRadius: '4px' }}
                    >Save</Button>
                    <Button 
                        variant='outlined' color='primary' size='small' style={{ borderRadius: '4px' }}
                        onClick={()=>{
                            setNewPaymentTerm('')
                            setPaymentTermField(false)
                        }}
                    >Cancel</Button>
                </div>
            </form>
        </div>
    </Modal>
  )
}

export default PaymentTermQuickAdd
